import React, { Component } from "react";
import { connect } from "react-redux";
import * as log from "loglevel";
import toastr from 'COMPONENTS/ShowTostr/ShowTostr';
import { getMessage } from "CONFIG/i18n";

// Other
import sound from "ASSETS/user-visit.mp3";
import Push from "push.js";

// UTILS
import { ERROR, CONFIG } from "UTILS/Constants";
import { getTerminalInfo} from "UTILS/Utility";

// Action
import { waitingUsersAction as actionFactory, sessionActions } from "CONFIG/ActionFactory";

// COMPONENTS
import withErrorHandler from "COMPONENTS/withErrorHandler/withErrorHandler";
import Spinner from "COMPONENTS/Spinner/Spinner";
import { socketMessage } from "WEBSOCKET/constants";
import { sendWebsocketMessage } from "WEBSOCKET/WebsocketHandler";
import WaitingUsers from "./WaitingUsers";

class WaitingUsersContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      waitSessionsDetails: {},
      totalSessions: 0,
      spinnerVisibility: false,
      showWaitingUsers: false,
      latestSession: null,
      sound: new Audio(sound)
    };
  }

  componentDidMount() {
    switch (Push.Permission.get()) {
      case Push.Permission.DEFAULT:
        Push.Permission.request();
        break;
      case Push.Permission.DENIED:
        toastr.info(getMessage("QR_WAITING_PUSH_DENIED"));
        break;
      default:
        break;
    }

    history.pushState(null, null, location.href);
    window.onpopstate = function (event) {
      history.go(1);
    };
    this.getWaitSessionsList(
      this.props.waitingUsersData.sessionListPageSize,
      this.props.waitingUsersData.displayPage
    );
  }

  setWaitingUsersData = (page, limit) => {
    actionFactory.setWaitingUsersData(
      {
        displayPage: page,
        sessionListPageSize: limit
      }
    );
  }

  getWaitSessionsList = (limit = 10, page = 0) => {
    const requestBodyData = {
      limit,
      page
    };
    actionFactory.getSessionWaitListAction(requestBodyData).then(
      (response) => {
        const sessionList = response.data.data.sessionsList;
        if (sessionList && sessionList.length >= 1) {
          const serverLatestTime = response.data.data.latestSession[0].created_time;
          if (!this.state.latestSession) {
            this.state.latestSession = serverLatestTime;
          } else if (serverLatestTime > this.state.latestSession) {
            this.state.latestSession = serverLatestTime;
            if (document.hasFocus()) {
              this.state.sound.play();
            }
            if (Push.Permission.has()) {
              Push.create(getMessage("QR_WAITING_PUSH_TITLE"), {
                body: getMessage("QR_WAITING_PUSH_MSG"),
                timeout: 300000,
                onClick: function () {
                  window.focus();
                  this.close();
                }
              });
            }

            let blinkFlag = true;
            function setTitleMsgFlash() {
              document.getElementsByTagName("title")[0].innerHTML = blinkFlag ? 'Finplex eXcloser' : getMessage("QR_WAITING_BROWSER_BLINK");
              blinkFlag = !blinkFlag;
              if (document.hasFocus() && !blinkFlag) {
                if (Push.Permission.has()) {
                  Push.clear();
                }
              } else {
                setTimeout(setTitleMsgFlash, 1000);
              }
            }
            setTitleMsgFlash();
          }
        }
        this.setState({
          waitSessionsDetails: response.data.data,
          totalSessions: response.data.data.total,
          spinnerVisibility: false,
          showWaitingUsers: true
        });
      },
      (error) => {
        log.error("ERROR:", error);
        /*
        if (error.code !== ERROR.NOT_AUTHORIZED) {
          toastr.error(getMessage(error.code));
        }
        */
        this.setState({
          spinnerVisibility: false
        });
      }
    );
  }

  backToMenu = () => {
    this.props.history.push(CONFIG.path.createSession);
    this.setState({
      showWaitingUsers: false
    });
  }

  joinSession = (sessionKey) => {
    getTerminalInfo().then ( terminalInfo => {
      sessionActions.joinSessionAction(sessionKey, this.props.uriIdentifier, terminalInfo, undefined, this.props.userName).then(
        (response) => {
          const sessionJoinPayload = {
            data: {
              category: socketMessage.category.SESSION,
              action: socketMessage.subCategories.SESSION.JOIN,
              userName: this.props.userName,
              sessionKey: this.props.sessionKey,
              token: response.data.data.token
            }
          };
          this.props.history.push(CONFIG.path.dashboard);
          sendWebsocketMessage(
            socketMessage.events.MESSAGE,
            sessionJoinPayload
          );
        },
        (error) => {
          // eslint-disable-next-line no-unused-expressions
          toastr.error(getMessage(error.code));
        }
      );
    });
  }

  render() {
    return (
      <>
        <Spinner showSpinner={this.state.spinnerVisibility} />
        {this.state.showWaitingUsers && (
          <WaitingUsers
            setWaitingUsersData={this.setWaitingUsersData}
            pageSize={this.pageSize}
            displaySize={this.displaySize}
            backToMenu={this.backToMenu}
            waitSessionsDetails={this.state.waitSessionsDetails}
            getWaitSessionsList={this.getWaitSessionsList}
            totalSessions={this.state.totalSessions}
            waitingUsersData={this.props.waitingUsersData}
            joinSession={this.joinSession}
            language={this.props.language}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  language: state.LanguageReducer.language,
  waitingUsersData: state.SessionReducer.waitingUsersData
});

export default withErrorHandler(
  connect(
    mapStateToProps
  )(WaitingUsersContainer)
);
